// Native cookie utilities
export const setCookie = (name, value, days) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));

    // Detect if we're on HTTPS (production) or HTTP (192.168.1.12)
    const isSecure = window.location.protocol === 'https:';

    // Build cookie string with appropriate security flags
    let cookieStr = `${name}=${value};expires=${expires.toUTCString()};path=/`;

    // Add Secure flag for HTTPS
    if (isSecure) {
        cookieStr += '; Secure';
    }

    // Add SameSite attribute for cross-site compatibility
    cookieStr += '; SameSite=Lax';

    document.cookie = cookieStr;
};

export const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

export const removeCookie = (name) => {
    const isSecure = window.location.protocol === 'https:';
    let cookieStr = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
    if (isSecure) {
        cookieStr += '; Secure';
    }
    cookieStr += '; SameSite=Lax';
    document.cookie = cookieStr;
};
